import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../pagePC/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_cc853a52 from 'nuxt_plugin_plugin_cc853a52' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_69de03d6 from 'nuxt_plugin_cookieuniversalnuxt_69de03d6' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_dayjsplugin_f333c860 from 'nuxt_plugin_dayjsplugin_f333c860' // Source: ./dayjs-plugin.js (mode: 'all')
import nuxt_plugin_axios_1f184f26 from 'nuxt_plugin_axios_1f184f26' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_gtm_4679d683 from 'nuxt_plugin_gtm_4679d683' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_image_490a5530 from 'nuxt_plugin_image_490a5530' // Source: ./image.js (mode: 'all')
import nuxt_plugin_ga_bee0a0d6 from 'nuxt_plugin_ga_bee0a0d6' // Source: ../plugins/ga.js (mode: 'client')
import nuxt_plugin_iconfont_964faec8 from 'nuxt_plugin_iconfont_964faec8' // Source: ../assets/iconfont.js (mode: 'client')
import nuxt_plugin_swiper_f2c22992 from 'nuxt_plugin_swiper_f2c22992' // Source: ../plugins/swiper.js (mode: 'client')
import nuxt_plugin_login_03d93b94 from 'nuxt_plugin_login_03d93b94' // Source: ../plugins/login.js (mode: 'client')
import nuxt_plugin_vuePersistedstate_7cd3e19b from 'nuxt_plugin_vuePersistedstate_7cd3e19b' // Source: ../plugins/vuePersistedstate.js (mode: 'client')
import nuxt_plugin_apmError_73fdac36 from 'nuxt_plugin_apmError_73fdac36' // Source: ../plugins/apmError.js (mode: 'client')
import nuxt_plugin_vconsole_df8cb624 from 'nuxt_plugin_vconsole_df8cb624' // Source: ../plugins/vconsole.js (mode: 'client')
import nuxt_plugin_veevalidate_472eb3da from 'nuxt_plugin_veevalidate_472eb3da' // Source: ../plugins/veevalidate.js (mode: 'all')
import nuxt_plugin_toast_336f5ab8 from 'nuxt_plugin_toast_336f5ab8' // Source: ../plugins/toast.js (mode: 'all')
import nuxt_plugin_tool_f2ea37d2 from 'nuxt_plugin_tool_f2ea37d2' // Source: ../plugins/tool.js (mode: 'all')
import nuxt_plugin_axios_673f0e09 from 'nuxt_plugin_axios_673f0e09' // Source: ../plugins/axios.js (mode: 'all')
import nuxt_plugin_index_bdae880c from 'nuxt_plugin_index_bdae880c' // Source: ../plugins/mixins/index.js (mode: 'all')
import nuxt_plugin_vuelazyload_1ecc0a4e from 'nuxt_plugin_vuelazyload_1ecc0a4e' // Source: ../plugins/vue-lazyload.js (mode: 'client')
import nuxt_plugin_activity_43fd3e3a from 'nuxt_plugin_activity_43fd3e3a' // Source: ../api/activity.js (mode: 'all')
import nuxt_plugin_homeApi_1a724b6a from 'nuxt_plugin_homeApi_1a724b6a' // Source: ../api/homeApi.js (mode: 'all')
import nuxt_plugin_baseApi_977ac048 from 'nuxt_plugin_baseApi_977ac048' // Source: ../api/baseApi.js (mode: 'all')
import nuxt_plugin_productApi_cd4886c4 from 'nuxt_plugin_productApi_cd4886c4' // Source: ../api/productApi.js (mode: 'all')
import nuxt_plugin_categoryApi_08968949 from 'nuxt_plugin_categoryApi_08968949' // Source: ../api/categoryApi.js (mode: 'all')
import nuxt_plugin_userApi_43e66156 from 'nuxt_plugin_userApi_43e66156' // Source: ../api/userApi.js (mode: 'all')
import nuxt_plugin_wishApi_01c1dd9c from 'nuxt_plugin_wishApi_01c1dd9c' // Source: ../api/wishApi.js (mode: 'all')
import nuxt_plugin_blogApi_4509b026 from 'nuxt_plugin_blogApi_4509b026' // Source: ../api/blogApi.js (mode: 'all')
import nuxt_plugin_customerImageApi_165f9bcc from 'nuxt_plugin_customerImageApi_165f9bcc' // Source: ../api/customerImageApi.js (mode: 'all')
import nuxt_plugin_reviewApi_780a03a3 from 'nuxt_plugin_reviewApi_780a03a3' // Source: ../api/reviewApi.js (mode: 'all')
import nuxt_plugin_cartApi_5a285ceb from 'nuxt_plugin_cartApi_5a285ceb' // Source: ../api/cartApi.js (mode: 'all')
import nuxt_plugin_orderApi_8632cf86 from 'nuxt_plugin_orderApi_8632cf86' // Source: ../api/orderApi.js (mode: 'all')
import nuxt_plugin_addressApi_2f0d73e3 from 'nuxt_plugin_addressApi_2f0d73e3' // Source: ../api/addressApi.js (mode: 'all')
import nuxt_plugin_pageSeo_7d87f631 from 'nuxt_plugin_pageSeo_7d87f631' // Source: ../plugins/pageSeo.js (mode: 'all')
import nuxt_plugin_vant_fdd8840e from 'nuxt_plugin_vant_fdd8840e' // Source: ../plugins/vant (mode: 'all')
import nuxt_plugin_videoPlayer_3b9711f4 from 'nuxt_plugin_videoPlayer_3b9711f4' // Source: ../plugins/videoPlayer (mode: 'client')
import nuxt_plugin_activeDialogApi_3f2c2d39 from 'nuxt_plugin_activeDialogApi_3f2c2d39' // Source: ../api/activeDialogApi.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Remy hair extensions,Virgin remy hair,virgin brazilian hair","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0"},{"http-equiv":"X-UA-Compatible","content":"IE=edge"},{"hid":"description","name":"description","content":"velvethairextension"},{"hid":"keywords","name":"keywords","content":"velvethairextension-keywords"},{"name":"format-detection","content":"telephone=no"},{"name":"theme-color","content":"#FFFFFF"},{"name":"msapplication-navbutton-color","content":"#FFFFFF"},{"name":"og:title","content":"Remy hair extensions,Virgin remy hair,virgin brazilian hair"}],"link":[],"style":[],"script":[{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e].p&&e[e][p]()))?1:0})(window,'navigator','doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":""}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_cc853a52 === 'function') {
    await nuxt_plugin_plugin_cc853a52(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_69de03d6 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_69de03d6(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjsplugin_f333c860 === 'function') {
    await nuxt_plugin_dayjsplugin_f333c860(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_1f184f26 === 'function') {
    await nuxt_plugin_axios_1f184f26(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_4679d683 === 'function') {
    await nuxt_plugin_gtm_4679d683(app.context, inject)
  }

  if (typeof nuxt_plugin_image_490a5530 === 'function') {
    await nuxt_plugin_image_490a5530(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_ga_bee0a0d6 === 'function') {
    await nuxt_plugin_ga_bee0a0d6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_iconfont_964faec8 === 'function') {
    await nuxt_plugin_iconfont_964faec8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_swiper_f2c22992 === 'function') {
    await nuxt_plugin_swiper_f2c22992(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_login_03d93b94 === 'function') {
    await nuxt_plugin_login_03d93b94(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuePersistedstate_7cd3e19b === 'function') {
    await nuxt_plugin_vuePersistedstate_7cd3e19b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_apmError_73fdac36 === 'function') {
    await nuxt_plugin_apmError_73fdac36(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vconsole_df8cb624 === 'function') {
    await nuxt_plugin_vconsole_df8cb624(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_472eb3da === 'function') {
    await nuxt_plugin_veevalidate_472eb3da(app.context, inject)
  }

  if (typeof nuxt_plugin_toast_336f5ab8 === 'function') {
    await nuxt_plugin_toast_336f5ab8(app.context, inject)
  }

  if (typeof nuxt_plugin_tool_f2ea37d2 === 'function') {
    await nuxt_plugin_tool_f2ea37d2(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_673f0e09 === 'function') {
    await nuxt_plugin_axios_673f0e09(app.context, inject)
  }

  if (typeof nuxt_plugin_index_bdae880c === 'function') {
    await nuxt_plugin_index_bdae880c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuelazyload_1ecc0a4e === 'function') {
    await nuxt_plugin_vuelazyload_1ecc0a4e(app.context, inject)
  }

  if (typeof nuxt_plugin_activity_43fd3e3a === 'function') {
    await nuxt_plugin_activity_43fd3e3a(app.context, inject)
  }

  if (typeof nuxt_plugin_homeApi_1a724b6a === 'function') {
    await nuxt_plugin_homeApi_1a724b6a(app.context, inject)
  }

  if (typeof nuxt_plugin_baseApi_977ac048 === 'function') {
    await nuxt_plugin_baseApi_977ac048(app.context, inject)
  }

  if (typeof nuxt_plugin_productApi_cd4886c4 === 'function') {
    await nuxt_plugin_productApi_cd4886c4(app.context, inject)
  }

  if (typeof nuxt_plugin_categoryApi_08968949 === 'function') {
    await nuxt_plugin_categoryApi_08968949(app.context, inject)
  }

  if (typeof nuxt_plugin_userApi_43e66156 === 'function') {
    await nuxt_plugin_userApi_43e66156(app.context, inject)
  }

  if (typeof nuxt_plugin_wishApi_01c1dd9c === 'function') {
    await nuxt_plugin_wishApi_01c1dd9c(app.context, inject)
  }

  if (typeof nuxt_plugin_blogApi_4509b026 === 'function') {
    await nuxt_plugin_blogApi_4509b026(app.context, inject)
  }

  if (typeof nuxt_plugin_customerImageApi_165f9bcc === 'function') {
    await nuxt_plugin_customerImageApi_165f9bcc(app.context, inject)
  }

  if (typeof nuxt_plugin_reviewApi_780a03a3 === 'function') {
    await nuxt_plugin_reviewApi_780a03a3(app.context, inject)
  }

  if (typeof nuxt_plugin_cartApi_5a285ceb === 'function') {
    await nuxt_plugin_cartApi_5a285ceb(app.context, inject)
  }

  if (typeof nuxt_plugin_orderApi_8632cf86 === 'function') {
    await nuxt_plugin_orderApi_8632cf86(app.context, inject)
  }

  if (typeof nuxt_plugin_addressApi_2f0d73e3 === 'function') {
    await nuxt_plugin_addressApi_2f0d73e3(app.context, inject)
  }

  if (typeof nuxt_plugin_pageSeo_7d87f631 === 'function') {
    await nuxt_plugin_pageSeo_7d87f631(app.context, inject)
  }

  if (typeof nuxt_plugin_vant_fdd8840e === 'function') {
    await nuxt_plugin_vant_fdd8840e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_videoPlayer_3b9711f4 === 'function') {
    await nuxt_plugin_videoPlayer_3b9711f4(app.context, inject)
  }

  if (typeof nuxt_plugin_activeDialogApi_3f2c2d39 === 'function') {
    await nuxt_plugin_activeDialogApi_3f2c2d39(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
